import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CheckboxModule, RippleModule, ButtonModule, InputTextModule, FontAwesomeModule, RouterLink],
})
export class LoginComponent {
  constructor() {}
}
